import { render, staticRenderFns } from "./ScoreView.vue?vue&type=template&id=5b5ad298&scoped=true"
import script from "./ScoreView.vue?vue&type=script&lang=js"
export * from "./ScoreView.vue?vue&type=script&lang=js"
import style0 from "./ScoreView.vue?vue&type=style&index=0&id=5b5ad298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ad298",
  null
  
)

export default component.exports